import React, { useRef, useState } from "react";
import logo from "../assets/appnest_logo.png";
import ButtonCompo from "../component/ButtonCompo";
import loginVid from "../assets/login.mp4";
import PasswordField from "../component/PasswordField";
import InputField from "../component/InputField";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import AlertBox from "../component/AlertBox";
import { LinearProgress } from "@mui/material";
import axios from "axios";
import { SERVER_URL } from "../constant";
import { employeeLogin } from "../store/employeeAuth.slice";
import { reloadToggle } from "../store/reload.slice";
import { MuiOtpInput } from "mui-one-time-password-input";

function EmployeeForgotPassword() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [enableOtpField, setEnableOtpField] = useState(false);
  const [enablePasswordField, setEnablePasswordField] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  async function generateEmail() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/verify/generate/verificiation/email`,
        method: "post",
        data: {
          email: email,
        },
        withCredentials: true,
      });
      setEnableOtpField(true);
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Please try again");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  async function verifyOTP() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/verify/email/otp/verify`,
        method: "post",
        data: {
          email: email,
          givenOtp: otp,
        },
        withCredentials: true,
      });
      setEnableOtpField(false);
      setEnablePasswordField(true);
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Please try again");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  async function changePassword() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/forgot-password`,
        method: "post",
        data: {
          newPassword: newPassword,
        },
        withCredentials: true,
      });
      navigate("/employee/signin")
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message || "Please try again");
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex items-center justify-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-1/2 hidden lg:flex h-[100vh]">
          <video
            src={loginVid}
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover"
          />
        </div>
        <div className="w-full lg:w-1/2 h-full flex flex-col justify-center items-center py-10">
          <img src={logo} className="w-[10rem] mb-[3rem]" alt="" />
          {enableOtpField === true ? (
            <div className="w-[20rem] flex flex-col justify-center items-center">
              <div className="text-left w-full mb-5">
                <p className="text-[23px] font-semibold">OTP Verification</p>
                <span className="text-[15px] text-slate-500">
                  Please verify the OTP that has been to {email}
                </span>
              </div>
              <MuiOtpInput
                value={otp}
                length={6}
                className="!gap-[2px]"
                onChange={(value) => setOtp(value)}
              />
              <ButtonCompo
                variant="contained"
                className="!mt-5 w-full"
                onClick={verifyOTP}
              >
                Verify
              </ButtonCompo>
            </div>
          ) : enablePasswordField === true ? (
            <div className="w-full flex justify-center items-center">
              <div className="w-[20rem] flex flex-col justify-center items-center">
                <div className="text-left w-full mb-5">
                  <p className="text-[23px] font-semibold">Change Password</p>
                  <span className="text-[15px] text-slate-500">
                    Please change your old password.
                  </span>
                </div>
                <div className="w-full space-y-5">
                  <InputField
                    label="Password"
                    onChange={(e) => setNewPassword(e?.target?.value)}
                  />
                </div>
                <ButtonCompo
                  variant="contained"
                  className="!mt-5 w-full"
                  onClick={changePassword}
                >
                  Change password
                </ButtonCompo>
              </div>
            </div>
          ) : (
            <div className="w-full flex justify-center items-center">
              <div className="w-[20rem] flex flex-col justify-center items-center">
                <div className="text-left w-full mb-5">
                  <p className="text-[23px] font-semibold">Forgot Password</p>
                  <span className="text-[15px] text-slate-500">
                    Please provide your personal email to reset the password.
                  </span>
                </div>
                <div className="w-full space-y-5">
                  <InputField
                    label="Email"
                    onChange={(e) => setEmail(e?.target?.value)}
                  />
                </div>
                <ButtonCompo
                  variant="contained"
                  className="!mt-5 w-full"
                  onClick={generateEmail}
                >
                  send verification mail
                </ButtonCompo>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default EmployeeForgotPassword;
